import Image from 'next/image'
import cx from 'classnames'
import { ArtistProps } from '../../../../types'
import { NEXT_IMAGE_QUALITY } from '~constants'
import styles from './DayEvent.module.scss'
import { FormattedEvent } from '../../../../types/Event'

export const DayEvent = ({
  handleDateSelection,
  artist,
  event,
  eventsTime
}: {
  handleDateSelection: (event: FormattedEvent[], artist: ArtistProps) => void
  artist: ArtistProps
  event: FormattedEvent[]
  eventsTime: string[]
}) => {
  // Formats the event times to show up to two times, separated by commas
  const getEventTimes = (eventTimes: string[]) => {
    if (eventTimes?.length == 1) {
      return <span>{eventTimes[0]}</span>
    } else {
      return eventTimes
        .slice(0, 2)
        .map((time: string, index: number) =>
          index < 1 ? <span key={index}>{time},&nbsp;&nbsp;</span> : <span key={index}>{time}&nbsp;&nbsp;</span>
        )
    }
  }

  const artistImage = artist?.calendarMonthViewImage

  return (
    <div
      key={artist?.artistId}
      onClick={() => handleDateSelection(event, artist)}
      className={styles['event-container']}
    >
      <div className={styles['event-copy-container']}>
        <span className={styles['event-title']}>{artist?.artistName}</span>
        <div className={styles['calendar__events']}>
          {getEventTimes(eventsTime ?? [])}
          {eventsTime?.length > 2 && (
            <span className={cx(styles['more-events'])}>&nbsp; + {eventsTime?.length - 2} more</span>
          )}
        </div>
      </div>
      {artistImage?.url && (
        <Image
          alt={artistImage?.altText || ''}
          src={artistImage?.url}
          fill
          style={{ objectFit: 'cover' }}
          className={styles['edp-image']}
          quality={NEXT_IMAGE_QUALITY}
        />
      )}
    </div>
  )
}
